import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { Field, Form, Formik } from 'formik'
import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import { CLOSE, SECONDARY } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import { SUB_GROUP_TITLE_TEXT_MAX } from 'app/constants/group'
import { DIALOG_KEYS } from '../constants'

const EditNameSubGroup = () => {
  const { formatMessage } = useIntl()
  const { dialogState, closeDialog, setLoading } = useGroupDialog()
  const { open, action, isLoading } =
    dialogState[DIALOG_KEYS.SUB_GROUP_EDIT_NAME]

  const handleSubmit = async (values, { setFieldError }) => {
    setLoading(DIALOG_KEYS.SUB_GROUP_EDIT_NAME, true)
    const data = {
      name: values.name,
      tagId: action?.tag.id,
    }

    action?.onSubmit?.({ data, setFieldError })
  }

  return (
    <SimpleDialog
      id="dialog-add-group"
      open={open}
      title={
        <div
          style={{ maxWidth: '500px', width: '500px' }}
          className="text-blue-950 py-5 px-10 text-16 font-medium"
        >
          <FormattedMessage id="groupsv4.detail.edit.subgroupName.title" />
        </div>
      }
      isLoading={isLoading}
      onClose={() => closeDialog(DIALOG_KEYS.SUB_GROUP_EDIT_NAME)}
    >
      <div className="py-5 px-10">
        <Formik
          initialValues={{
            name: action?.tag.name,
          }}
          validate={(values) => {
            const errors = {}
            if (!values.name) {
              errors.groupName = formatMessage({
                id: 'composeDialog.field.required',
              })
            }

            if (values.name?.length > SUB_GROUP_TITLE_TEXT_MAX) {
              errors.name = formatMessage(
                {
                  id: 'maximum.characters.allowed',
                },
                { limit: SUB_GROUP_TITLE_TEXT_MAX },
              )
            }

            return errors
          }}
          onSubmit={handleSubmit}
        >
          {({ dirty, isValid, isSubmitting, touched, errors }) => (
            <Form>
              <div className="mb-5 w-full">
                <div className="w-fit flex text-14 font-medium text-blue-950 mb-1">
                  <FormattedMessage id="groupv4.addSubgroup.title" />
                  <label className="px-2 text-red-500">*</label>
                </div>

                <Field name="name">
                  {({ field }) => (
                    <SimpleInput
                      {...field}
                      id="name"
                      disabled={isLoading}
                      type="text"
                      className="h-48 w-full mb-1 sm:mb-0 bg-white rounded-8 text-blue-950"
                      placeholder={formatMessage({
                        id: 'groupv4.addSubgroup.title',
                      })}
                      error={Boolean(errors.name)}
                      helperText={errors.name}
                    />
                  )}
                </Field>
              </div>

              <div className="flex justify-center space-x-5 m-5">
                <OutlinedButtons
                  type="button"
                  color={CLOSE}
                  disabled={isSubmitting || isLoading}
                  onClick={() => closeDialog(DIALOG_KEYS.SUB_GROUP_EDIT_NAME)}
                >
                  <FormattedMessage id="action.cancel" />
                </OutlinedButtons>
                <ContainedButton
                  color={SECONDARY}
                  type="submit"
                  isLoading={isLoading}
                  disabled={!dirty || !isValid || isSubmitting || isLoading}
                >
                  <FormattedMessage id="action.update" />
                </ContainedButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </SimpleDialog>
  )
}

export default EditNameSubGroup
